import { LocalizationProvider } from '@mui/x-date-pickers';
import LuxonUtils from '@date-io/luxon';

export const DatePickerProvider = (props: any): React.ReactElement => {
  return <LocalizationProvider utils={LuxonUtils} {...props} />;
};
